export const STATUS_OKAY = 'okay';
export const STATUS_WARNING = 'warning';
export const STATUS_ERROR = 'error';

const all = [STATUS_OKAY, STATUS_ERROR, STATUS_WARNING] as const;
export type SeoStatusType = typeof all[number];
